import { useEffect, useState } from "react";
import axios from "axios";
import "./Users.css"; // Don't forget to create this CSS file

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('token'); // Get token from localStorage

        if (!token) {
          throw new Error('No token found, please log in');
        }
        const response = await axios.get(
          `https://filesapi.infomanav.in/api/aws/get-all-users`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("User data from API:", response.data);
        setUsers(response.data.users); // <-- this will fix the 'No users found' issue
      } catch (err) {
        console.error("Error fetching users:", err);
        setError(err.response?.data?.message || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const formatDate = (inputDate) => {
    if (!inputDate) return "-";

    try {
      // Extract parts like "16 April, 2025 at 1:24:21 pm IST"
      const parts = inputDate.split(" at ");
      const datePart = parts[0].replace(/^[A-Za-z]+,\s*/, ""); // remove weekday
      const timePart = parts[1]?.split(":");
      const hours = timePart[0];
      const minutes = timePart[1];
      const meridian = timePart[2]?.includes("pm") ? "pm" : "am";

      return `${datePart} at ${hours}:${minutes} ${meridian}`;
    } catch {
      return inputDate; // fallback
    }
  };

  return (
    <div className="users-wrapper">
      {loading && <p className="status-text">Loading users...</p>}
      {error && <p className="status-text error">Error: {error}</p>}

      {!loading && !error && (
        <div className="table-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th>Avatar</th>
                <th>Name</th>
                <th>Email</th>
                <th>Contact</th>
                <th>Permission</th>
                <th>Bucket type</th>
                <th>Last Login</th>
                <th>Folder Size</th>
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user, index) => (
                  <tr key={index}>
                    <td>
                      {user.userAvatar ? (
                        <img
                          src={user.userAvatar}
                          alt="avatar"
                          className="user-avatar"
                        />
                      ) : (
                        <div className="user-avatar-fallback">
                          {user.name?.charAt(0).toUpperCase() || "U"}
                        </div>
                      )}
                    </td>

                    <td>{user.name || "-"}</td>
                    <td>{user.email || "-"}</td>
                    <td>{user.contact || "-"}</td>
                    <td>{user.permission || "-"}</td>
                    <td>{user.bucketType || "-"}</td>
                    <td>{formatDate(user.lastLoginAt)}</td>
                    <td>{user.folderSize || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="no-data">
                    No users found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Users;
